export const LOG_ACTIVITY_REQUEST = '@activity/LOG_ACTIVITY_REQUEST';
export const LOG_ACTIVITY_SUCCESS = '@activity/LOG_ACTIVITY_SUCCESS';
export const LOG_ACTIVITY_FAILED = '@activity/LOG_ACTIVITY_FAILED';
